import React, { useState, useContext, useEffect } from 'react';

import { UserContext } from './../Context/UserContext';
import { RouteProps } from 'react-router-dom';
import { apiClient } from './../API/Auth/apiClient';
import history from '../Utils/history';
import { AppContext } from './../Context/AppContext';
import { useTranslation } from 'react-i18next';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import { Checkbox, FormControlLabel, Grid, Typography, makeStyles, Theme, createStyles, withStyles, Button } from '@material-ui/core';
import { Container } from 'reactstrap';
import { colors } from '../Constants/constants';
import { routes } from '../Routing/routes';

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		root: {
			padding: theme.spacing(3, 2),
			display: 'flex',
			flexGrow: 1,
			flexDirection: 'column',
			margin: 'auto',
			justifyContent: 'center',
			textAlign: 'center',
			height: '80%',
			maxWidth: '460px',
		},
		content: {},
	})
);

export const Login: React.FC<RouteProps> = (props) => {
	const [userName, setUsername] = React.useState('');
	const [password, setPassword] = React.useState('');
	const [rememberMe, setRememberMe] = React.useState(false);
	const [valid, setValid] = React.useState(false);
	const [loginError, setLoginError] = useState(false);

	const userContext = useContext(UserContext);
	const appContext = useContext(AppContext);
	const { t } = useTranslation();
	const classes = useStyles(props);

	const StyledButton = withStyles({
		root: {
			background: colors.main,
			borderRadius: 3,
			border: 0,
			color: 'white',
			height: 36,
			padding: '0 30px',
		},
		label: {
			textTransform: 'capitalize',
		},
	})(Button);

	useEffect(() => {
		if (userContext.isLogged) {
			apiClient.logout(false);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const doLogin = () => {
		if (valid) {
			appContext.setLoaderVisible(true);
			apiClient
				.login(userName, password, rememberMe)
				.then(function (response) {
					appContext.setLoaderVisible(false);
					if (response) {
						const query = new URLSearchParams(props.location?.search);
						const returnUrl = query.get('returnUrl');

						if (returnUrl != null) {
							history.replace({
								search: '',
							});
							history.push(returnUrl);
						} else {
							history.push(routes.root);
						}
					}
				})
				.catch(function (error) {
					setLoginError(true);
				})
				.finally(() => {
					appContext.setLoaderVisible(false);
				});
		}
	};

	var f: ValidatorForm;
	function validatorListener(result: boolean) {
		f.isFormValid(true)
			.then((value) => {
				setValid(value);
			})
			.catch((ex) => {
				setValid(false);
			});
	}
	const catchReturn = (ev: any) => {
		if (ev.key === 'Enter') {
			ev.preventDefault();
			doLogin();
		}
	};

	return (
		<div className={classes.root}>
			<Container maxWidth='xs'>
				<ValidatorForm
					ref={(form) => {
						f = form as ValidatorForm;
					}}
					instantValidate={true}
					debounceTime={100}
					onSubmit={() => {}}
					onError={(e) => alert(e)}
				>
					<Grid container spacing={2} direction='row' alignItems='center' justify='center'>
						<Grid item xs={12}>
							<TextValidator
								variant='standard'
								margin='dense'
								fullWidth
								id='email'
								label={t('common.inputs.email')}
								name='email'
								autoComplete='email'
								autoFocus
								onChange={(e) => setUsername((e.target as HTMLInputElement).value)}
								value={userName}
								onKeyPress={catchReturn}
								validators={['required', 'isEmail', 'maxStringLength:50']}
								errorMessages={[
									t('common.validations.required'),
									t('common.validations.emailNotValid'),
									t('common.validations.maxLength', { length: 50 }),
								]}
								validatorListener={validatorListener}
							/>
						</Grid>
						<Grid item xs={12}>
							<TextValidator
								variant='standard'
								margin='normal'
								fullWidth
								name='password'
								label={t('common.inputs.password')}
								type='password'
								id='password'
								autoComplete='current-password'
								onChange={(e) => setPassword((e.target as HTMLInputElement).value)}
								value={password}
								onKeyPress={catchReturn}
								validators={['required']}
								errorMessages={[t('common.validations.required')]}
								validatorListener={validatorListener}
							/>
						</Grid>
						<Grid container item xs={12} alignContent='flex-end' alignItems='center' justify='flex-start'>
							<Grid container item xs={6}>
								<FormControlLabel
									control={
										<Checkbox color='primary' checked={rememberMe} onChange={(e) => setRememberMe(e.target.checked)} />
									}
									label={t('login.rememberMe')}
								/>
							</Grid>
							{/* <Grid container item xs={6} justify='flex-end'>
											<p className='forgotPassword' onClick={() => setOpen(true)}>
												{t('login.forgotPassword')}
											</p>
										</Grid> */}
						</Grid>

						<Grid container item xs={12} alignContent='flex-start' alignItems='flex-start' justify='center'>
							<StyledButton variant='contained' color='primary' onClick={doLogin} disabled={!valid}>
								{t('login.login')}
							</StyledButton>
						</Grid>
						{loginError && (
							<Grid container item xs={12} alignContent='center' alignItems='baseline' justify='center'>
								<Typography component='p' variant='subtitle2' style={{ marginTop: '20px', color: 'red' }}>
									{t('login.loginError')}
								</Typography>
							</Grid>
						)}
					</Grid>
				</ValidatorForm>
			</Container>
		</div>
	);
};
